import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, UncontrolledTooltip } from 'reactstrap';

const NewButton = ({ id, size, title = '', onClick = () => null, noSpaces = false }) => (
    <>
        <Button
            className="bg-light text-primary"
            id={id || ''}
            onClick={onClick}
            size={size || 'md'}>
            {!noSpaces && <>&nbsp;</>}<FontAwesomeIcon icon={faPlus} />{!noSpaces && <>&nbsp;</>}
        </Button>
        {id && <UncontrolledTooltip target={id}>{title}</UncontrolledTooltip>}
    </>
);

export default NewButton;
